/* src/app/components/close-modal-button/close-modal-button.component.scss */
ion-icon {
  height: 100%;
  padding: 5px;
  color: black;
}
ion-icon.red {
  color: #eb445a !important;
}
ion-button {
  min-height: 0;
  height: 32px;
}
ion-button::part(native) {
  margin: 0 !important;
  padding: 0 !important;
}
/*# sourceMappingURL=close-modal-button.component-RC52MGL7.css.map */
